<template>
  <search-layout>
    <template v-slot:contents>
      <field-input title="연도" cols="2">
        <v-select
          v-model="baseYear"
          :items="baseYearList"
          outlined hide-details dense
          background-color="white"
        />
      </field-input>
      <field-input title="기간 단위" cols="2">
        <v-radio-group v-model="type" row>
          <v-radio label="연" value="Y" />
          <v-radio label="분기" value="Q" />
          <v-radio label="월" value="M" />
        </v-radio-group>
      </field-input>
    </template>
    <template v-slot:button>
      <search-btn @click="search" />
    </template>
  </search-layout>
</template>
<script>
import SearchLayout from "@/common/layout/SearchLayout.vue";
import SearchBtn from "@/common/components/SearchBtn.vue";
import FieldInput from "@/common/components/input/FieldInput.vue";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "LoanStaticsSearchbar",
  components: {FieldInput, SearchBtn, SearchLayout},
  mixins: [DateMixin],
  data() {
    return {
      baseYear: "",
      baseYearList: [],
      type: "M"
    }
  },
  beforeMount() {
    const startYear = 2025;
    const currentYear = new Date().getFullYear();
    const yearCount = currentYear - startYear + 1;

    this.baseYearList = [];

    for (let i = 0; i < yearCount; i++) {
      this.baseYearList.push(startYear + i);
    }

    this.baseYearList.reverse();

    this.baseYear = currentYear;
  },
  methods: {
    search() {
      const params = {
        yyyy: this.baseYear,
        type: this.type
      };
      this.$emit("search", params);
    }
  }
}
</script>